module.exports = __webpack_public_path__ + "static/img/icon.551539f8.png";